export default {
    props: {
        editableConfirmation: {
            type: Boolean | String | Function,
            kComposite: 'editable.confirmation'
        }, 
        editableCancelDelete: {
            type: String,
            kComposite: 'editable.cancelDelete'
        }, 
        editableConfirmDelete: {
            type: String,
            kComposite: 'editable.confirmDelete'
        }, 
        editableCreateAt: {
            type: String,
            kComposite: 'editable.createAt'
        }, 
        editableDestroy: {
            type: Boolean,
            kComposite: 'editable.destroy'
        }, 
        editableMode: {
            type: String,
            kComposite: 'editable.mode'
        }, 
        editableTemplate: {
            type: String | Function,
            kComposite: 'editable.template'
        }, 
        editableUpdate: {
            type: Boolean,
            kComposite: 'editable.update'
        }, 
        editableWindow: {
            type: Object,
            kComposite: 'editable.window'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Editable.js